import React from "react";
import Routes from "./Routes";
import { Toaster } from "react-hot-toast";
import { useAuth } from "./contexts/AuthContext";
import { useSessionTimeout } from "./hooks/useSessionTimeout";

function App() {
  const { user } = useAuth();

  // ✅ 5-min session timeout — auto logout on inactivity
  // Warns at 4 min, logs out at 5 min, only active when user is logged in
  useSessionTimeout(user);

  return (
    <>
      <Routes />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: "var(--color-card)",
            color: "var(--color-foreground)",
            border: "1px solid var(--color-border)",
          },
          success: {
            iconTheme: {
              primary: "var(--color-success)",
              secondary: "var(--color-card)",
            },
          },
          error: {
            iconTheme: {
              primary: "var(--color-destructive)",
              secondary: "var(--color-card)",
            },
          },
        }}
      />
    </>
  );
}

export default App;